<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <loader v-show="loading" />
    <CSidebarBrand class="d-md-down-none" to="/">
      <span v-if="!$store.state.sidebarMinimize">{{title.long}}</span>
      <span v-if="$store.state.sidebarMinimize">{{title.sort}}</span>
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="nav2" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import { HTTP, HTTPAUTH } from "./../lib/httplib.js";
import Loader from "../components/Loader.vue";

export default {
  name: "TheSidebar",
  data() {
    this.loadAppInfo()
    return {
      title: {},
      loading: false,
      nav2: [],
    };
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  components: { Loader },
  created() {
    this.loadMenu()
  },
  methods: {
    loadAppInfo () {
      HTTP.get("/api/app/info").then(res => {
        this.title = res.data.title
      })
    },
    loadMenu() {
      this.loading = true;
      HTTPAUTH.get("/api/menu/my")
        .then((res) => {
          this.nav2 = res.data.data;
          this.loading = false;
        })
        .catch((eres) => {
          console.log(eres);
          this.loading = false;
        });
    },
  },
};
</script>
